import { AsyncSingleSelectField, CharField, NumberField, RadiosField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Tavola } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"
import { useImmagineLazy, useImmaginiLazy } from "../../hooks/immagini"
import { useAtlanteLazy, useAtlantiLazy } from "../../hooks/atlanti"
import { ImagePreviewSelectField } from "../../components/ImagePreviewSelectField"

export default function TavolaForm({ col = 8, hasAtalante = false }: { col?: number; hasAtalante?: boolean }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Tavola>()

  const fetchImmagine = useImmagineLazy()
  const fetchImmagini = useImmaginiLazy()

  const fetchAtlante = useAtlanteLazy()
  const fetchAtlanti = useAtlantiLazy()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      {hasAtalante && (
        <AsyncSingleSelectField
          label="Atlante"
          layout="horizontal"
          placeholder="Seleziona un atlante"
          required
          onChange={(value) => {
            setFieldValue("atlante", value)
          }}
          clearable
          value={values.atlante}
          loadOptions={(inputValue: string) => {
            return fetchAtlanti({ search: inputValue }).then((atlanti) => {
              return atlanti.results.map((atlante) => ({
                label: atlante.nome,
                value: atlante.id,
              }))
            })
          }}
          loadInitialValue={(id: number) =>
            fetchAtlante(id).then((atlante) => {
              return { label: atlante.nome, value: atlante.id }
            })
          }
          isValid={submitCount > 0 ? !getIn(errors, "atlante") : undefined}
          errorMessage={getIn(errors, "atlante")}
        ></AsyncSingleSelectField>
      )}

      <ImagePreviewSelectField
        label="Immagine principale"
        placeholder="Cerca per titolo, edizione, tecnica, tag..."
        required
        value={values.immagine_principale}
        initialImage={values.immagine_principale_data}
        onChange={(value) => {
          setFieldValue("immagine_principale", value)
        }}
        fetchImage={fetchImmagine}
        fetchImages={fetchImmagini}
        isValid={submitCount > 0 ? !getIn(errors, "immagine_principale") : undefined}
        errorMessage={getIn(errors, "immagine_principale")}
      />

      <RadiosField
        label="Template griglia"
        layout="horizontal"
        value={values.template_griglia || "Orizzontale"}
        onChange={(value) => {
          setFieldValue("template_griglia", value)
        }}
        options={[
          { label: "Orizzontale", value: "Orizzontale" },
          { label: "Verticale", value: "Verticale" },
        ]}
        isValid={submitCount > 0 ? !getIn(errors, "template_griglia") : undefined}
        errorMessage={getIn(errors, "template_griglia")}
        required
      />

      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.titolo}
        onChange={(value) => {
          setFieldValue("titolo", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "titolo") : undefined}
        errorMessage={getIn(errors, "titolo")}
        required
      />
      <CharField
        label="Sottotitolo"
        layout="horizontal"
        value={values.sottotitolo}
        onChange={(value) => {
          setFieldValue("sottotitolo", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "sottotitolo") : undefined}
        errorMessage={getIn(errors, "sottotitolo")}
        required
      />

      <CharField
        label="Ubicazione"
        layout="horizontal"
        value={values.ubicazione}
        onChange={(value) => {
          setFieldValue("ubicazione", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "ubicazione") : undefined}
        errorMessage={getIn(errors, "ubicazione")}
        required
      />
      <NumberField
        label="Numero canto"
        layout="horizontal"
        value={Number.isNaN(values.numero_canto!) ? undefined : values.numero_canto!}
        onChange={(value) => {
          setFieldValue("numero_canto", value ? Number(value) : undefined)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "numero_canto") : undefined}
        errorMessage={getIn(errors, "numero_canto")}
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione || ""}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />

      <SwitchField
        label="Bozza"
        layout="horizontal"
        value={values.bozza}
        onChange={(value) => {
          setFieldValue("bozza", value)
        }}
      />
    </Col>
  )
}
